import { render, staticRenderFns } from "./DocumentContentViewer.vue?vue&type=template&id=cfc9d8c6&scoped=true"
import script from "./DocumentContentViewer.vue?vue&type=script&lang=js"
export * from "./DocumentContentViewer.vue?vue&type=script&lang=js"
import style0 from "./DocumentContentViewer.vue?vue&type=style&index=0&id=cfc9d8c6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfc9d8c6",
  null
  
)

export default component.exports